import { ButtonProps } from 'antd'

import { ReactNode } from 'react'

import { Button } from 'shared/ui/Button'

interface Props extends ButtonProps {
  text: string
  prefixIcon?: ReactNode
}

const PrimaryButton = ({ text, prefixIcon, className, ...props }: Props) => {
  return (
    <Button
      className={`h-auto py-[10px] px-[16px] text-[16px] leading-[20px] font-medium text-white bg-dark_blue_1 rounded-[12px] ${className}`}
      type="primary"
      {...props}
    >
      {prefixIcon}
      <span className="mt-[-1px]">{text}</span>
    </Button>
  )
}

export default PrimaryButton
